<template>
  <v-dialog
    v-model="value"
    persistent
    :max-width="maxWidth"
  >
    <v-card>
      <v-card-title>
        <span class="title">{{ title }}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          small
          class="primary"
          @click="$emit('confirm')"
        >
          Ok
        </v-btn>
        <v-btn
          small
          @click="$emit('cancel')"
        >
          Відміна
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value", "maxWidth", "title"],
};
</script>